import React from "react";
import Card from "components/card";
import { Headset } from "lucide-react";
import AccessButton from "components/button/accessbutton";

const SupportCard = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-blue-200 bg-gradient-to-br from-white to-blue-50/30">
            <div className="pb-6 p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="p-2 rounded-full bg-gradient-to-br from-blue-500 to-purple-500">
                        <Headset className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden bg-blue-100 text-blue-700 border-blue-200 text-[9px]">
                            Quick Action
                        </span>
                    </div>
                </div>
                <p className="text-[12px] text-slate-700 mb-1">
                    Get Support in Motion
                </p>
                <p className="text-[10px] text-slate-700 mb-3">
                    Need help? Raise a ticket instantly
                </p>
                <div className="transform-none">
                    <AccessButton
                        label="Raise Support Ticket"
                        to="/console/it-support"
                        iconStart={<Headset className="w-3.5 h-3.5 -mr-1.5" />}
                        btnClass="btn-support"
                    />
                </div>  
            </div>
        </Card>
    )
};
export default SupportCard;